<template>
    <div class="left-header">
        <!--<img class="logo" src="@c/assets/img/fushima_logo_60.png" alt="DMS">-->
       
        <el-dropdown trigger="click">
            <span class="el-dropdown-link">
                <i class="el-icon-user"></i> 
                <template v-if="user">
                    <span> {{user.username}} </span>
                </template>
                <template v-if="user && user.empresa">
                    <span> - {{user.empresa}} </span>
                </template>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>

            <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                        v-if="user"
                        icon="el-icon-user" 
                        @click.native="$emit('openWindow',{id: user.user_id, name: 'Perfil', entidad: 'user', link:`${window.distributionapp.publicPath}/user/${user.user_id}`})">
                        Perfil
                    </el-dropdown-item>

                    <el-dropdown-item
                        icon="el-icon-set-up"
                        v-if="modalCompanies.companies.length"
                        @click.native="showModalCompanies()">
                        Cambiar empresa
                    </el-dropdown-item>

                <el-dropdown-item icon="el-icon-switch-button" @click.native="logout()">Desconectar</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <el-dialog
        title="Cambiar empresa"
        :visible.sync="modalCompanies.open"
        width="400px">

            <p style="margin-bottom: 10px; word-break: initial">
                Una vez seleccionada la empresa se actualizará el navegador
            </p>

            <el-alert
            v-if="modalCompanies.error"
                title="Ha ocurrido un error"
                type="error">
            </el-alert>

            <ul class="companies">
                <li 
                v-for="(company, c) in modalCompanies.companies.filter(f => f.NOMBRE !== user.empresa)" 
                :key="c"
                @click="selectCompany(company)"
                :class="[{selected: modalCompanies.selected.IDTERCER === company.IDTERCER}]">
                    {{ company.NOMBRE }}
                </li>
            </ul>

            <span slot="footer" class="dialog-footer">
                <el-button @click="modalCompanies.open = false">Cancelar</el-button>
                <el-button type="primary" @click="saveCompany()" :loading="modalCompanies.loading">Cambiar empresa</el-button>
            </span>

        </el-dialog>

        <!--<p class="time">{{ time }}</p>-->
        
        <!--<el-menu :collapse="true" v-if="user && user.menu && user.menu.length">
            <el-submenu index="1">
                <template slot="title">
                    <i class="el-icon-setting"></i>
                </template>
                <el-submenu v-for="(item,i) in user.menu" :key="i" :index="`1-${i}`">
                    <span slot="title">{{item.name}}</span>
                    <el-menu-item v-for="(option,o) in item.options" :key="o" :index="`1-${i}-${o}`" @click="goMenu(option.link)">{{option.name}}</el-menu-item>
                </el-submenu>
            </el-submenu>
        </el-menu>-->
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import moment from 'moment'
    import {
        setToken,
        getCompanies, 
        saveCompanies
    } from '@/helpers/api.js'

	export default {
        name: 'MenuHeader',
        data() {
            return {
                window,
                time: '',
                modalCompanies: {
                    open: false,
                    error: false,
                    loading: false,
                    companies: [],
                    selected: ''
                }
            }
        },
        computed: {
            ...mapState({
				user: state => state.user.data
			})
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                //this.startTime()
                this.fetchCompanies()
            },
			logout () {
                this.$confirm('¿Seguro que desea cerrar sesión?', 'Desconectar', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('accessTokenDms')
                    localStorage.removeItem('menu')
                    window.location.reload(true)
                })
            },
            goMenu(link) {
                this.openwindow(link,'_blank')
            },
            startTime() {

                let _self = this
                function _move (timeout = 60) {
                    _self.time = moment().format("DD/MM/YYYY, HH:mm")
                    setTimeout(() => {
                        _move();
                    }, timeout)
                }

                let segundos = moment().format("ss")
                if (segundos < 60) {
                    _move(60 - segundos)
                } else {
                    _move()
                }
                
            },
            // Cambiar empresa
            async fetchCompanies() {

                this.modalCompanies.error = false
                this.modalCompanies.companies = []

                // Solo en APK lanzaremos la petición de empresas
                if(this.user.app !== 'APK') return

                try {

                    let {data} = await getCompanies()
                    this.modalCompanies.companies = data

                } catch (e) {

                    console.log('error', e)
                }
            },
            showModalCompanies() {
                this.modalCompanies.open = true
                this.modalCompanies.selected = ''
            },
            selectCompany(company) {
                this.modalCompanies.selected = company
            },
            async saveCompany() {

                this.modalCompanies.error = false

                try {

                    this.modalCompanies.loading = true

                    let {data} = await saveCompanies({
                        id: this.modalCompanies.selected.IDTERCER
                    })

                    let token = data.accessToken

                    localStorage.removeItem('accessToken')
                    localStorage.setItem('accessToken', token)
                    setToken(token)

                    window.location.reload()

                } catch (e) {

                    this.modalCompanies.error = true

                } finally {

                    this.modalCompanies.loading = false
                    this.modalCompanies.open = false
                }
                
            }
        }
	}
</script>

<style lang="scss">
.left-header {
    width: fit-content;
    align-items: center;
    display: flex;

    .el-dropdown-link {
        cursor: pointer;
        span {
            display: none;
            @media(min-width: 768px) { display: inline; }
        }
    }

    i.el-icon-arrow-down.el-icon--right {
        color: #ffffff6e;
    }

    span.el-dropdown-link.el-dropdown-selfdefine {
        color: white;
    }

    // Modal companies
    ul.companies {
        display: flex;
        flex-flow: column;
        align-items: start;
        li {
            border: 1px solid #dddddd !important;
            margin-bottom: 5px !important;
            width: -webkit-fill-available;
            padding: 5px 10px !important;
            color: #686868 !important;
            border-radius: 4px!important;
            &.selected {
                background-color:#409eff !important;
                color: white !important;
            }
        }
    }
}
</style>